var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAuthFacebook = function SvgAuthFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 15"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1877F2",
    fillRule: "evenodd",
    d: "M14.003 7.26c0-3.89-3.135-7.042-7.001-7.042S0 3.37 0 7.26c0 3.515 2.56 6.428 5.908 6.957V9.296H4.13V7.261h1.778V5.709c0-1.765 1.045-2.74 2.644-2.74.766 0 1.567.137 1.567.137V4.84h-.883c-.87 0-1.14.542-1.14 1.1v1.32h1.941l-.31 2.036H8.095v4.922c3.348-.529 5.908-3.442 5.908-6.957",
    clipRule: "evenodd"
  })));
};
export default SvgAuthFacebook;